import { registerSW } from "virtual:pwa-register";

/**
 * Registers the service worker. A new version is applied the next time the app is
 * hidden, so an update never reloads the page under her fingers. Unsynced text is
 * safe either way: it lives in IndexedDB.
 */
export function setupPwa() {
  if (!("serviceWorker" in navigator)) return;
  const update = registerSW({
    immediate: true,
    onNeedRefresh() {
      const apply = () => {
        if (document.visibilityState === "hidden") {
          document.removeEventListener("visibilitychange", apply);
          void update(true);
        }
      };
      document.addEventListener("visibilitychange", apply);
    },
  });
}
